import { FormattedText, MentionInputSuggestion } from "client/Components";
import { MentionData } from "client/Components/MentionInput/converters";
import {
	Dispatch,
	SetStateAction,
	useCallback
} from "react";
import { convertToMentionData } from "./MentionSuggestionBox";
import { isCancelledError } from "client_legacy/ndaw/cancellation";
import {
	AlertManager,
	useAlerts,
	useUnmountedCancellation
} from "client/Hooks";
import { localize } from "client_legacy/ndaw/culture";
import { CommentFormData } from "../HubCommentSection/CommentForm/CommentForm";
import { HubCommentSectionService } from "../HubCommentSection/HubCommentSection";

export type InsertSuggestionHandler = (suggestion: MentionInputSuggestion) => Promise<void>;

export function useInsertSuggestionHandler(
	service: HubCommentSectionService,
	setMentionData: Dispatch<SetStateAction<CommentFormData>>

): InsertSuggestionHandler {
	const globalCancellation: AbortSignal = useUnmountedCancellation();
	const alertManager: AlertManager = useAlerts();

	return useCallback(
		async (suggestion: MentionInputSuggestion): Promise<void> => {
			const mention: MentionData = convertToMentionData(suggestion);

			setMentionData(
				x => ({
					...x,
					mentionData: [...x.mentionData, mention]
				})
			);

			try {
				const hasAccess: boolean = await service.doesUserHaveAccess(
					mention.userId,
					globalCancellation
				);

				if (!hasAccess) {
					alertManager.showError(
						<FormattedText
							text={localize("_DisplayNameDoesNotHaveAccessToTheItem")}
							thingsToReplace={[
								{ what: "{{DisplayName}}", filler: mention.displayName }
							]}
						/>
					);
				}
			} catch (e) {
				if (isCancelledError(e)) {
					return;
				}

				console.error(e);
				alertManager.showError(localize("_GeneralErrorMessage"));
			}
		},
		[
			alertManager,
			service,
			globalCancellation,
			setMentionData
		]
	);
}
